import React from "react";
import PropTypes from "prop-types";
import RSCol from "reactstrap/lib/Col";

import { gatherClasses, gatherConditionalProps } from "../../lib/utils";

const Col = props => {
  const { dataTestId, children } = props;

  return (
    <RSCol
      data-testid={dataTestId}
      {...gatherConditionalProps(props, "xs", "sm", "md", "lg", "xl")}
      className={gatherClasses(props)}
    >
      {children}
    </RSCol>
  );
};

const stringOrNumberProp = PropTypes.oneOfType([
  PropTypes.number,
  PropTypes.string
]);
const columnProps = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
  PropTypes.bool,
  PropTypes.shape({
    size: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.number,
      PropTypes.string
    ]),
    order: stringOrNumberProp,
    offset: stringOrNumberProp
  })
]);

Col.propTypes = {
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

Col.defaultProps = {
  dataTestId: "orion-col"
};

Col.displayName = "OrionCol";

export default Col;
